import { crudeDatabase } from "../data/crudeDatabase";



/* ==========================================
   EXTRACT NUMERIC VALUE
========================================== */

function getNumericValue(value) {

    if (value === null || value === undefined)
        return null;

    if (typeof value === "number")
        return value;

    const text = String(value);

    const nums =
        text.match(/-?\d+(\.\d+)?/g);

    if (!nums)
        return null;

    if (nums.length === 1)
        return Number(nums[0]);

    return (
        Number(nums[0]) +
        Number(nums[1])
    ) / 2;

}


/* ==========================================
   FLOW WEIGHTED AVERAGE
========================================== */

function weightedAverage(

    value1,
    value2,

    flow1,
    flow2

) {

    const v1 =
        getNumericValue(value1);

    const v2 =
        getNumericValue(value2);

    if (v1 === null && v2 === null)
        return null;

    if (v1 === null)
        return v2;

    if (v2 === null)
        return v1;

    const total =
        flow1 + flow2;

    if (total <= 0)
        return 0;

    return (

        (v1 * flow1) +

        (v2 * flow2)

    ) / total;

}


/* ==========================================
   RECURSIVE PROPERTY BLENDER
========================================== */

function blendObject(

    obj1,
    obj2,

    flow1,
    flow2

) {

    if (!obj1 && !obj2)
        return {};

    if (!obj1)
        return obj2;

    if (!obj2)
        return obj1;

    const result = {};

    const keys = new Set([

        ...Object.keys(obj1),

        ...Object.keys(obj2)

    ]);

    keys.forEach(key => {

        const value1 = obj1?.[key];

        const value2 = obj2?.[key];

        /* ==========================
           NESTED OBJECT
        ========================== */

        if (

            value1 &&
            typeof value1 === "object" &&
            !Array.isArray(value1)

        ) {

            result[key] = blendObject(

                value1,
                value2,

                flow1,
                flow2

            );

            return;

        }

        /* ==========================
           NUMERIC VALUE
        ========================== */

        if (

            key === "value" ||

            key === "secondaryValue"

        ) {

            result[key] = weightedAverage(

                value1,
                value2,

                flow1,
                flow2

            );

            return;

        }

        /* ==========================
           COPY EVERYTHING ELSE
        ========================== */

        result[key] =

            value1 ??

            value2;

    });

    return result;

}


function mixObjects(

    oldObject,

    newObject,

    oldVolume,

    newVolume

) {

    return blendObject(

        oldObject,

        newObject,

        oldVolume,

        newVolume

    );

}




/* ==========================================
   MIX TANK CONTRIBUTORS
========================================== */

function mixContributors(

    existing = [],

    incoming = [],

    existingVolume,

    incomingVolume

) {

    const totalVolume =
        existingVolume + incomingVolume;

    if (totalVolume <= 0)
        return [];

    const map = {};

    /* ===============================
       EXISTING INVENTORY
    =============================== */

    existing.forEach(item => {

        map[item.crudeKey] = {

            crudeKey: item.crudeKey,

            crudeName: item.crudeName,

            volume:

                (item.contribution / 100) *

                existingVolume

        };

    });

    /* ===============================
       INCOMING INVENTORY
    =============================== */

    incoming.forEach(item => {

        const volume =

            (item.contribution / 100) *

            incomingVolume;

        if (!map[item.crudeKey]) {

            map[item.crudeKey] = {

                crudeKey: item.crudeKey,

                crudeName: item.crudeName,

                volume: 0

            };

        }

        map[item.crudeKey].volume += volume;

    });

    /* ===============================
       CONVERT BACK TO %
    =============================== */

    return Object.values(map).map(item => ({

        crudeKey: item.crudeKey,

        crudeName: item.crudeName,

        contribution:

            (item.volume / totalVolume) * 100

    }));

}





export function generateBlend() {

    /* ==========================================
       READ TANKS
    ========================================== */

    const tank1 =
        JSON.parse(
            localStorage.getItem("CRUDE_TANK_1")
        ) || {};

    const tank2 =
        JSON.parse(
            localStorage.getItem("CRUDE_TANK_2")
        ) || {};

    /* ==========================================
       GET CRUDES
    ========================================== */

    const crude1 =
        tank1.crudeKey
            ? crudeDatabase[tank1.crudeKey]
            : null;

    const crude2 =
        tank2.crudeKey
            ? crudeDatabase[tank2.crudeKey]
            : null;


console.log("========== BLEND ENGINE ==========");
console.log("Tank1", tank1);
console.log("Tank2", tank2);

console.log("Tank1 crudeKey", tank1.crudeKey);
console.log("Tank2 crudeKey", tank2.crudeKey);

console.log("Crude1", crude1);
console.log("Crude2", crude2);

console.log("Available crudeDatabase keys", Object.keys(crudeDatabase));
console.log("==================================");



/* ==========================================
   READ LIVE FLOWS
========================================== */

const FIC_13010 =
    Number(localStorage.getItem("FIC_13010")) || 0;

const FIC_13012 =
    Number(localStorage.getItem("FIC_13012")) || 0;

const FIC_13020 =
    Number(localStorage.getItem("FIC_13020")) || 0;

const FIC_13017 =
    Number(localStorage.getItem("FIC_13017")) || 0;



/* ==========================================
   BUILD STREAMS
========================================== */

const streams = [

    {

        tank: "V-1301",

        crudeKey: tank1.crudeKey,

        crude: crude1,

        flow: FIC_13010

    },

    {

        tank: "V-1302",

        crudeKey: tank1.crudeKey,

        crude: crude1,

        flow: FIC_13012

    },

    {

        tank: "V-1303",

        crudeKey: tank2.crudeKey,

        crude: crude2,

        flow: FIC_13020

    },

    {

        tank: "V-1304",

        crudeKey: tank2.crudeKey,

        crude: crude2,

        flow: FIC_13017

    }

];


/* ==========================================
   ACTIVE BLEND STREAMS
========================================== */

const activeStreams =

    streams.filter(stream =>

        stream.flow > 0 &&

        stream.crude

    );



    
/* ==========================================
   TOTAL BLEND FLOW
========================================== */

const totalFlow = streams.reduce(

    (total, stream) => total + stream.flow,

    0

);


    /* ==========================================
   BLEND CONTRIBUTORS
========================================== */

const contributors =

    activeStreams.map(stream => ({

        tank: stream.tank,

        crudeKey: stream.crudeKey,

        crudeName: stream.crude.name,

        flow: stream.flow,

        contribution:
            totalFlow > 0

                ? (stream.flow / totalFlow) * 100

                : 0

    }));




    


/* ==========================================
   FLOW BY CRUDE
========================================== */

const crude1Flow =
    FIC_13010 + FIC_13012;

const crude2Flow =
    FIC_13020 + FIC_13017;




/* ==========================================
   FIRST BLENDED PROPERTY
========================================== */

const blendedProperties = {

    bulkElementalComposition:

        blendObject(

            crude1?.bulkElementalComposition,

            crude2?.bulkElementalComposition,

            crude1Flow,

            crude2Flow

        ),

    physicalProperties:

        blendObject(

            crude1?.physicalProperties,

            crude2?.physicalProperties,

            crude1Flow,

            crude2Flow

        ),

    corrosionStability:

        blendObject(

            crude1?.corrosionStability,

            crude2?.corrosionStability,

            crude1Flow,

            crude2Flow

        ),

    traceMetals:

        blendObject(

            crude1?.traceMetals,

            crude2?.traceMetals,

            crude1Flow,

            crude2Flow

        ),

    saraAnalysis:

        blendObject(

            crude1?.saraAnalysis,

            crude2?.saraAnalysis,

            crude1Flow,

            crude2Flow

        ),

    lightEnds:

        blendObject(

            crude1?.lightEnds,

            crude2?.lightEnds,

            crude1Flow,

            crude2Flow

        ),

    tbpDistillation:

        blendObject(

            crude1?.tbpDistillation,

            crude2?.tbpDistillation,

            crude1Flow,

            crude2Flow

        ),

    cutYields:

        blendObject(

            crude1?.cutYields,

            crude2?.cutYields,

            crude1Flow,

            crude2Flow

        ),

    residueProperties:

        blendObject(

            crude1?.residueProperties,

            crude2?.residueProperties,

            crude1Flow,

            crude2Flow

        )

};




/* ==========================================
   PRODUCT YIELD PREDICTION
========================================== */

const blendedCutYields =
    blendedProperties.cutYields || {};

const predictedProducts = {};

Object.keys(blendedCutYields).forEach(product => {

    const item =
        blendedCutYields[product];

    const yieldVol =
        getNumericValue(
            item?.yieldVol?.value
        );

    if (yieldVol === null) return;

    predictedProducts[product] = {

        yieldVol,

        flow:

            totalFlow *

            (yieldVol / 100)

    };

});




    /* ==========================================
   BLEND RATIOS
========================================== */

const ratio1 =
    totalFlow > 1
        ? crude1Flow / totalFlow
        : 0;

const ratio2 =
    totalFlow > 1
        ? crude2Flow / totalFlow
        : 0;


/* ==========================================
   DISPLAY RATIOS
========================================== */

const ratio1Percent =
    ratio1 * 100;

const ratio2Percent =
    ratio2 * 100;



const now = new Date();

const blendID =
    `BLD-${

        now.getFullYear()

    }${

        String(now.getMonth() + 1)
            .padStart(2,"0")

    }${

        String(now.getDate())
            .padStart(2,"0")

    }-${

        String(now.getHours())
            .padStart(2,"0")

    }${

        String(now.getMinutes())
            .padStart(2,"0")

    }${

        String(now.getSeconds())
            .padStart(2,"0")

    }`;



    let blendName = "";

if (crude1 && crude2) {

    blendName =
        `${crude1.name} + ${crude2.name}`;

}
else if (crude1) {

    blendName =
        crude1.name;

}
else if (crude2) {

    blendName =
        crude2.name;

}



/* ==========================================
   AUTOMATIC BLEND GRADE
========================================== */

let blendGrade = "UNKNOWN";

const apiGravity =
    blendedProperties
        ?.physicalProperties?.[7]?.value;

const sulfur =
    blendedProperties
        ?.bulkElementalComposition?.[3]?.value;

const api =
    getNumericValue(apiGravity);

const sulfurValue =
    getNumericValue(sulfur);

if (

    api !== null &&
    sulfurValue !== null

) {

    if (

        api >= 35 &&
        sulfurValue < 0.5

    ) {

        blendGrade = "LIGHT SWEET";

    }

    else if (

        api >= 25 &&
        sulfurValue < 1.0

    ) {

        blendGrade = "MEDIUM SWEET";

    }

    else if (

        api >= 20

    ) {

        blendGrade = "MEDIUM SOUR";

    }

    else {

        blendGrade = "HEAVY SOUR";

    }

}





/* ==========================================
   WEIGHTED PROPERTY CALCULATOR
========================================== */

function weightedProperty(value1, value2) {

    if (totalFlow <= 0) return null;

    return (

        (value1 * crude1Flow) +

        (value2 * crude2Flow)

    ) / totalFlow;

}




const blendResult = {

    blendInfo: {

        blendID,

        blendName,

        blendGrade,

        status: totalFlow > 0
            ? "BLENDING"
            : "IDLE",

        timestamp: Date.now()

    },

    flowInfo: {

    crude1Flow,

    crude2Flow,

    totalFlow,

    ratio1,

    ratio2,

    ratio1Percent,

    ratio2Percent

},
 /* =====================================
       ORIGINAL FEED CRUDE DATA
    ===================================== */

    feedCrudes: {

    crude1: crude1 || null,

    crude2: crude2 || null

},
    streams,

    contributors,

    properties: blendedProperties

};

localStorage.setItem(

    "ACTIVE_BLEND",

    JSON.stringify(blendResult)

);

return blendResult;









    return {

    blendInfo: {

        blendID,

        blendName,

        blendGrade: "",

        status: "IDLE",

        timestamp: Date.now()

    },

    flowInfo: {

    crude1Flow,

    crude2Flow,

    totalFlow,

    ratio1,

    ratio2,

    ratio1Percent,

    ratio2Percent

},

    streams,
    contributors,
    properties: blendedProperties,
    predictedProducts

};

}